import { seo } from "../../../common/helpers/seo";

import lazyComponent from "./lazy";
import withRouter from "../../utils/withRouter";

export default {
    component: withRouter(lazyComponent),
    renderSeo: (store, allMessage, lang) => {
        return seo({
            title: "Newsletter",
            allMessage,
            lang,
        });
    },
};
